<div class="sumax-dialog-head">
	<div style="display: flex;align-items: center;align-content: flex-first;">
		<div class="mr-3"><i class="fa fa-list" style="font-size: 1.25em !important; color: #646c9a;"></i></div>
		<h3 class="sumax-dialog-head-title py-1 mr-1" style="line-height: 1.2;
		font-family: Soho Gothic Pro;
		-ms-text-size-adjust: 100%;
		-webkit-font-smoothing: antialiased;"><strong>{{ tittle }}</strong></h3>
	</div>
</div>
<mat-dialog-content class="p-3">
	<div class="modal-body px-3 py-0">
		<div class="row py-2">
			<div class="col-lg-4">
				<div class="input-group no-border">
					<input #elTxtBuscar type="text" class="form-control form-control-sm" placeholder="Buscar..."
						[formControl]="txtBuscar" (keyup.enter)="$event.stopPropagation();selectFirstSearch()">
					<div class="input-group-append">
						<div class="input-group-text">
							<i class="fas fa-search"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<ag-grid-angular class="ag-theme-balham" [columnDefs]="columnDefsActions" [domLayout]="'autoHeight'"
					[rowSelection]="rowSelection" [suppressDragLeaveHidesColumns]="true"
					[suppressPaginationPanel]="true" [suppressScrollOnNewData]="true"
					(cellKeyPress)="onCellKeyPress($event)" (gridReady)="onGridReady($event)"
					(paginationChanged)="onPaginationChanged()" [paginationPageSize]="paginationPageSize"
					[pagination]="pagination" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
					[overlayLoadingTemplate]="overlayLoadingTemplate">
				</ag-grid-angular>
			</div>
		</div>
		<div class="row row justify-content-center justify-content-sm-between" id="paginacion">
			<nav class="d-flex flex-wrap" aria-label="Page navigation example" *ngIf="paginas.length > 0">
				<ul class="pagination p-0 m-0">

					<li class="page-item" [ngClass]="gridApi.paginationGetCurrentPage() == 0?'disabled':''">
						<a class="page-link" (click)="onBtFirst()"><i class="fa fa-angle-double-left"></i></a>
					</li>
					<li class="page-item" [ngClass]="gridApi.paginationGetCurrentPage() == 0?'disabled':''">
						<a class="page-link" (click)="onBtPrevious()"><i class="fa fa-angle-left"></i></a>
					</li>

					<li class="page-item" *ngFor="let pagina of paginas"
						[ngClass]="pagina-1 == gridApi.paginationGetCurrentPage()?'active':''">
						<span class="page-link" *ngIf="pagina-1 == gridApi.paginationGetCurrentPage()">
							{{pagina}} </span>
						<a class="page-link" *ngIf="pagina-1 != gridApi.paginationGetCurrentPage()"
							(click)="onGoToPage(pagina-1)"> {{pagina}} </a>
					</li>


					<li class="page-item"
						[ngClass]="gridApi.paginationGetCurrentPage() == gridApi.paginationGetTotalPages()-1?'disabled':''">
						<a class="page-link" (click)="onBtNext()"><i class="fa fa-angle-right"></i></a>
					</li>
					<li class="page-item"
						[ngClass]="gridApi.paginationGetCurrentPage() == gridApi.paginationGetTotalPages()-1?'disabled':''">
						<a class="page-link" (click)="onBtLast()"><i class="fa fa-angle-double-right"></i></a>
					</li>


				</ul>
				<div class="d-flex mx-2 align-items-center input-group-sm">
					Mostrar
					<select [(ngModel)]="paginationPageSize" (change)="onPageSizeChanged($event)"
						class="custom-select mx-2">
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="15">15</option>
						<option value="20">20</option>
						<option value="25">25</option>
					</select>
					registros
				</div>
			</nav>

			<div class="d-flex justify-content-end mt-2 mt-sm-0">
				<li class="totalRegistros d-flex align-items-center flex-nowrap">
					<span #lbPageSize id="lbPageSize" class="value">0</span>
					<span class=" label"> Registros. </span>
					<span class=" label">Página </span>
					<span #lbCurrentPage id="lbCurrentPage" class=" value">0</span>
					<span class=" label"> de </span>
					<span #lbTotalPages id="lbTotalPages" class=" value">0</span>
				</li>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<div class="row p-3" style="border-top: 1px solid #ebedf2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;">
		<div class="col-lg-7 d-flex align-items-center">
		</div>
		<div class="col-lg-5 d-flex justify-content-end my-auto">
			<button #btnAceptar (click)="guardar()" (keyup.ArrowUp)="focusLastRow()"
				(keyup.ArrowRight)="btnCancelar.focus()" type="button" class="btn btn-success mr-3">Aceptar</button>
			<button #btnCancelar (click)="closeDialog()" (keyup.ArrowUp)="focusLastRow()"
				(keyup.ArrowLeft)="btnAceptar.focus()" type="button" class="btn btn-danger">Cancelar</button>
		</div>
	</div>
</mat-dialog-actions>